import React, { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useToast } from "../../../Utils/toastContext";
import Dropdown from "../../../Components/CustomDropdown/customdropdown";
import ConfirmContinueButton from "../../../Components/ContinueButton/continue-button";
import ConfirmResetButton from "../../../Components/ContinueButton/reset-button";
import { useNavigate, useLocation } from "react-router-dom";
import DocumentPreview from "../../Create-Investment/documentpreview";
import { setStepStatus } from "../../../Redux/store/onboardingFormSlice";
import LabelWithStatus from "../../../Components/Onbaording/label-with-status";
import { clearFileIdsRedux } from "../../../Redux/store/userSlice";
import ReviewPopup from "../../../Components/Onbaording/review-popup";

const UploadProof = ({ setCurrentStep }) => {
  const updateFieldStatus = useSelector(
    (state) => state.user.updateFieldStatus
  );
  const stepStatus = useSelector((state) => state.form.stepStatus);
  const isInvitee = useSelector((state) => state.user.isInvitee);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [loading, setLoading] = useState(false);
  const { showToast } = useToast();
  const [applicantCountry, setApplicantCountry] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [currentField, setCurrentField] = useState({});
  const [currentFieldName, setCurrentFieldName] = useState("");
  const [currentFieldValue, setCurrentFieldValue] = useState("");
  const [currentFieldType, setCurrentFieldType] = useState("");

  const [description, setDescription] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [expiryDate, setExpiryDate] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [expiryDateSecond, setExpiryDateSecond] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [documentNumber, setDocumentNumber] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [documentNumberSecond, setDocumentNumberSecond] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });

  const [fileThirdParty, setFileThirdParty] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [fileProof, setFileProof] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const fileProofRef = useRef(null);
  const fileThirdPartyRef = useRef(null);
  const filePhotoGraphicIdRef = useRef(null);
  const driverLicenseFrontRef = useRef(null);
  const driverLicenseBackRef = useRef(null);
  const fileNonPhotoGraphicIdRef = useRef(null);
  const driverLicenseBackRefFirst = useRef(null);
  const driverLicenseBackRefSecond = useRef(null);
  const customerId = useSelector((state) => state.form.onboardingCustomer);

  const [webLink, setWebLink] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });

  const [filePhotographicId, setFilePhotographicId] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [fileDriverLinsenceFront, setFileDriverLinsenceFront] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [fileDriverLinsenceBack, setFileDriverLinsenceBack] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [fileDriverLinsenceFrontFirst, setFileDriverLinsenceFrontFirst] =
    useState({
      verification_id: null,
      value: null,
      status: "pending",
      rejection_reason: null,
      rejection_comment: null,
      rejection_timestamp: null,
      rejected_by: null,
      comments: [],
    });
  const [fileDriverLinsenceFrontSecond, setFileDriverLinsenceFrontSecond] =
    useState({
      verification_id: null,
      value: null,
      status: "pending",
      rejection_reason: null,
      rejection_comment: null,
      rejection_timestamp: null,
      rejected_by: null,
      comments: [],
    });
  const [photoId, setphotoId] = useState(1);
  const [photoIdText, setphotoIdText] = useState("Passport");
  const [nonphotoId, setNonphotoId] = useState(1);
  const [nonphotoIdText, setNonphotoIdText] = useState("Utility Bill");
  const [fileNonPhotographicId, setfileNonPhotographicId] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [personalDataId, setPersonalDataId] = useState(1);
  const [personalDataIdText, setPersonalDataIdText] = useState("CV");

  const fileCVRef = useRef(null);
  const driverLicenseFrontRefFirst = useRef(null);
  const driverLicenseFrontRefSecond = useRef(null);
  const [signatory, setSignatory] = useState({
    verification_id: null,
    value: true,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });

  const [fileCV, setFileCV] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const filePhotoGraphicIdNonAusRef = useRef(null);
  const filePhotoGraphicIdNonAusRefSecond = useRef(null);

  const [photoIdFirst, setphotoIdFirst] = useState(1);
  const [photoIdFirstText, setphotoIdFirstText] = useState("Passport");
  const [photoIdSecond, setphotoIdSecond] = useState(2);
  const [photoIdSecondText, setphotoIdSecondText] =
    useState("Driver's License");

  const [filePhotographicIdFirst, setfilePhotographicIdFirst] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [filePhotographicIdSecond, setfilePhotographicIdSecond] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });

  const [fileDriverLinsenceBackFirst, setFileDriverLinsenceBackFirst] =
    useState({
      verification_id: null,
      value: null,
      status: "pending",
      rejection_reason: null,
      rejection_comment: null,
      rejection_timestamp: null,
      rejected_by: null,
      comments: [],
    });
  const [fileDriverLinsenceBackSecond, setFileDriverLinsenceBackSecond] =
    useState({
      verification_id: null,
      value: null,
      status: "pending",
      rejection_reason: null,
      rejection_comment: null,
      rejection_timestamp: null,
      rejected_by: null,
      comments: [],
    });

  const [preselectedPhotograpicId, setpreselectedPhotograpicId] = useState({
    value: 1,
    label: "Passport",
  });
  const [preselectedPhotograpicIdSecond, setpreselectedPhotograpicIdSecond] =
    useState({
      value: 2,
      label: "Driver's License",
    });
  const [preselectedPersonal, setpreselectedPersonal] = useState({
    value: 1,
    label: "CV",
  });
  const [preselectedNonPhotoId, setpreselectedNonPhotoId] = useState({
    value: 1,
    label: "Utility Bill",
  });
  const [preselectedPhotograpicIdFirst, setpreselectedPhotograpicIdFirst] =
    useState({
      value: 1,
      label: "Passport",
    });
  const [currentDocument, setcurrentDocument] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [photographicIdData, setphotographicIdData] = useState([]);
  const [nonPhotoData, setnonPhotoData] = useState([]);
  const [personalData, setpersonalData] = useState([]);
  const getCurrentDate = () => {
    const today = new Date();
    today.setMinutes(today.getMinutes() - today.getTimezoneOffset()); // Adjust for timezone
    return today.toISOString().split("T")[0]; // Get YYYY-MM-DD format
  };
  const checkFileNameExist = (selectedFile) => {
    if (
      (fileProof.value &&
        fileProof.value.file_name.toLowerCase() ===
          selectedFile.name.toLowerCase()) ||
      (fileThirdParty.value &&
        fileThirdParty.value.file_name.toLowerCase() ===
          selectedFile.name.toLowerCase()) ||
      (filePhotographicId.value &&
        filePhotographicId.value.file_name.toLowerCase() ===
          selectedFile.name.toLowerCase()) ||
      (fileDriverLinsenceFront.value &&
        fileDriverLinsenceFront.value.file_name.toLowerCase() ===
          selectedFile.name.toLowerCase()) ||
      (fileDriverLinsenceBack.value &&
        fileDriverLinsenceBack.value.file_name.toLowerCase() ===
          selectedFile.name.toLowerCase()) ||
      (fileNonPhotographicId.value &&
        fileNonPhotographicId.value.file_name.toLowerCase() ===
          selectedFile.name.toLowerCase()) ||
      (fileCV.value &&
        fileCV.value.file_name.toLowerCase() ===
          selectedFile.name.toLowerCase()) ||
      (filePhotographicIdFirst.value &&
        filePhotographicIdFirst.value.file_name.toLowerCase() ===
          selectedFile.name.toLowerCase()) ||
      (fileDriverLinsenceFrontFirst.value &&
        fileDriverLinsenceFrontFirst.value.file_name.toLowerCase() ===
          selectedFile.name.toLowerCase()) ||
      (fileDriverLinsenceBackFirst.value &&
        fileDriverLinsenceBackFirst.value.file_name.toLowerCase() ===
          selectedFile.name.toLowerCase()) ||
      (filePhotographicIdSecond.value &&
        filePhotographicIdSecond.value.file_name.toLowerCase() ===
          selectedFile.name.toLowerCase()) ||
      (fileDriverLinsenceBackSecond.value &&
        fileDriverLinsenceBackSecond.value.file_name.toLowerCase() ===
          selectedFile.name.toLowerCase()) ||
      (fileDriverLinsenceFrontSecond.value &&
        fileDriverLinsenceFrontSecond.value.file_name.toLowerCase() ===
          selectedFile.name.toLowerCase())
    ) {
      return true;
    } else {
      return false;
    }
  };
  const handleSelectPhotographicId = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setphotoId(selectedOption.value);
    setphotoIdText(selectedOption.label);
    handleDeleteDriverLinsenceBack();
    handleDeleteDriverLinsenceFront();
    handleDeleteFilePhotographicId();
  };
  const handleSelectPhotographicIdFirst = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    if (photoIdSecond == selectedOption.value) {
      showToast(
        "The selected photographic ID is already in use. Kindly select a different document.",
        "error"
      );
      setTimeout(() => {
        // Force re-render with previous valid selection
        setpreselectedPhotograpicIdFirst({ ...preselectedPhotograpicIdFirst });
      }, 300);
      return;
    }
    setphotoIdFirst(selectedOption.value);
    setphotoIdFirstText(selectedOption.label);
    handleDeleteDriverLinsenceBackFirst();
    handleDeleteDriverLinsenceFrontFirst();
    handleDeleteFilePhotographicIdFirst();
    setpreselectedPhotograpicIdFirst(selectedOption);
  };
  const handleSelectPhotographicIdSecond = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    if (photoIdFirst == selectedOption.value) {
      showToast(
        "The selected photographic ID is already in use. Kindly select a different document.",
        "error"
      );
      setTimeout(() => {
        // Force re-render with previous valid selection
        setpreselectedPhotograpicIdSecond({
          ...preselectedPhotograpicIdSecond,
        });
      }, 300);
      return;
    }
    setphotoIdSecond(selectedOption.value);
    setphotoIdSecondText(selectedOption.label);
    handleDeleteDriverLinsenceBackSecond();
    handleDeleteDriverLinsenceFrontSecond();
    handleDeleteFilePhotographicIdSecond();
    setpreselectedPhotograpicIdSecond(selectedOption);
  };
  const handleSelectPersonal = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setPersonalDataId(selectedOption.value);
    setPersonalDataIdText(selectedOption.label);
    handleDeleteFileCV();
  };
  const handleSelectNonPhoto = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setNonphotoId(selectedOption.value);
    setNonphotoIdText(selectedOption.label);
    handleDeleteFileNonPhotographicId();
  };
  const handleDeleteFileThirdParty = () => {
    setFileThirdParty({
      verification_id: null,
      value: null,
      status: "pending",
      rejection_reason: null,
      rejection_comment: null,
      rejection_timestamp: null,
      rejected_by: null,
      comments: [],
    });
    if (fileThirdPartyRef.current) {
      fileThirdPartyRef.current.value = null;
    }
  };
  const handleStatusClick = (docData, fieldText, fieldValue, fieldType) => {
    setCurrentField(docData);
    setCurrentFieldName(fieldText);
    setCurrentFieldValue(fieldValue);
    setCurrentFieldType(fieldType);
    dispatch(clearFileIdsRedux());
    setShowPopup(true);
  };
  const fileUploadNew = async (file) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {};

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/advisor/onboarding/customer/${customerId}/upload/file`;
    const formData3 = new FormData();
    formData3.append("file", file); // Append file
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: formData3,
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const handleFileClick = (e, rowData) => {
    setcurrentDocument(rowData);
    setIsModalOpen(true);
  };
  const handleFileChangeThirdParty = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (fileThirdPartyRef.current) {
          fileThirdPartyRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error"
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileThirdParty({
              ...fileThirdParty,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: "error" };
          }
        } catch (err) {
          setFileThirdParty({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: "error" };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
    e.target.value = "";
  };
  const handleFileChangeProof = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (fileProofRef.current) {
          fileProofRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error"
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileProof({
              ...fileProof,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: "error" };
          }
        } catch (err) {
          setFileProof({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: "error" };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
    e.target.value = "";
  };
  const handleDeleteFileProof = () => {
    setFileProof({
      verification_id: null,
      value: null,
      status: "pending",
      rejection_reason: null,
      rejection_comment: null,
      rejection_timestamp: null,
      rejected_by: null,
      comments: [],
    });
    if (fileProofRef.current) {
      fileProofRef.current.value = null;
    }
  };
  const handleFileChangePhotographicId = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (filePhotoGraphicIdRef.current) {
          filePhotoGraphicIdRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error"
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFilePhotographicId({
              ...filePhotographicId,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: "error" };
          }
        } catch (err) {
          setFilePhotographicId({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: "error" };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
    e.target.value = "";
  };
  const handleFileChangeDriverLincenseFront = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (driverLicenseFrontRef.current) {
          driverLicenseFrontRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error"
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileDriverLinsenceFront({
              ...fileDriverLinsenceFront,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: "error" };
          }
        } catch (err) {
          setFileDriverLinsenceFront({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: "error" };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
    e.target.value = "";
  };
  const handleFileChangeDriverLincenseFrontFirst = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (driverLicenseFrontRefFirst.current) {
          driverLicenseFrontRefFirst.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error"
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileDriverLinsenceFrontFirst({
              ...fileDriverLinsenceFrontFirst,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: "error" };
          }
        } catch (err) {
          setFileDriverLinsenceFrontFirst({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: "error" };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
    e.target.value = "";
  };
  const handleFileChangeDriverLincenseFrontSecond = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (driverLicenseFrontRefSecond.current) {
          driverLicenseFrontRefSecond.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error"
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileDriverLinsenceFrontSecond({
              ...fileDriverLinsenceFrontSecond,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: "error" };
          }
        } catch (err) {
          setFileDriverLinsenceFrontSecond({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: "error" };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
    e.target.value = "";
  };
  const handleDeleteFilePhotographicId = () => {
    setFilePhotographicId({
      verification_id: null,
      value: null,
      status: "pending",
      rejection_reason: null,
      rejection_comment: null,
      rejection_timestamp: null,
      rejected_by: null,
      comments: [],
    });
    if (filePhotoGraphicIdRef && filePhotoGraphicIdRef.current) {
      filePhotoGraphicIdRef.current.value = null;
    }
  };
  const handleDeleteDriverLinsenceFront = () => {
    setFileDriverLinsenceFront({
      verification_id: null,
      value: null,
      status: "pending",
      rejection_reason: null,
      rejection_comment: null,
      rejection_timestamp: null,
      rejected_by: null,
      comments: [],
    });
    if (driverLicenseFrontRef && driverLicenseFrontRef.current) {
      driverLicenseFrontRef.current.value = null;
    }
  };
  const handleDeleteDriverLinsenceFrontFirst = () => {
    setFileDriverLinsenceFrontFirst({
      verification_id: null,
      value: null,
      status: "pending",
      rejection_reason: null,
      rejection_comment: null,
      rejection_timestamp: null,
      rejected_by: null,
      comments: [],
    });
    if (driverLicenseFrontRefFirst && driverLicenseFrontRefFirst.current) {
      driverLicenseFrontRefFirst.current.value = null;
    }
  };
  const handleDeleteDriverLinsenceFrontSecond = () => {
    setFileDriverLinsenceFrontSecond({
      verification_id: null,
      value: null,
      status: "pending",
      rejection_reason: null,
      rejection_comment: null,
      rejection_timestamp: null,
      rejected_by: null,
      comments: [],
    });
    if (driverLicenseFrontRefSecond && driverLicenseFrontRefSecond.current) {
      driverLicenseFrontRefSecond.current.value = null;
    }
  };
  const handleFileChangeDriverLincenseBack = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (driverLicenseBackRef.current) {
          driverLicenseBackRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error"
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileDriverLinsenceBack({
              ...fileDriverLinsenceBack,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: "error" };
          }
        } catch (err) {
          setFileDriverLinsenceBack({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: "error" };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
    e.target.value = "";
  };
  const handleDeleteDriverLinsenceBack = () => {
    setFileDriverLinsenceBack({
      verification_id: null,
      value: null,
      status: "pending",
      rejection_reason: null,
      rejection_comment: null,
      rejection_timestamp: null,
      rejected_by: null,
      comments: [],
    });
    if (driverLicenseBackRef && driverLicenseBackRef.current) {
      driverLicenseBackRef.current.value = null;
    }
  };
  const handleDeleteDriverLinsenceBackFirst = () => {
    setFileDriverLinsenceBackFirst({
      verification_id: null,
      value: null,
      status: "pending",
      rejection_reason: null,
      rejection_comment: null,
      rejection_timestamp: null,
      rejected_by: null,
      comments: [],
    });
    if (driverLicenseBackRefFirst && driverLicenseBackRefFirst.current) {
      driverLicenseBackRefFirst.current.value = null;
    }
  };
  const handleDeleteDriverLinsenceBackSecond = () => {
    setFileDriverLinsenceBackSecond({
      verification_id: null,
      value: null,
      status: "pending",
      rejection_reason: null,
      rejection_comment: null,
      rejection_timestamp: null,
      rejected_by: null,
      comments: [],
    });
    if (driverLicenseBackRefSecond && driverLicenseBackRefSecond.current) {
      driverLicenseBackRefSecond.current.value = null;
    }
  };
  const handleFileChangeNonPhotographicId = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (fileNonPhotoGraphicIdRef.current) {
          fileNonPhotoGraphicIdRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error"
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setfileNonPhotographicId({
              ...fileNonPhotographicId,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: "error" };
          }
        } catch (err) {
          setfileNonPhotographicId({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: "error" };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
    e.target.value = "";
  };

  const handleDeleteFileNonPhotographicId = () => {
    setfileNonPhotographicId({
      verification_id: null,
      value: null,
      status: "pending",
      rejection_reason: null,
      rejection_comment: null,
      rejection_timestamp: null,
      rejected_by: null,
      comments: [],
    });
    if (fileNonPhotoGraphicIdRef && fileNonPhotoGraphicIdRef.current) {
      fileNonPhotoGraphicIdRef.current.value = null;
    }
  };
  const handleFileChangeCV = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (fileCVRef.current) {
          fileCVRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error"
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileCV({
              ...fileCV,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: "error" };
          }
        } catch (err) {
          setFileCV({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: "error" };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
    e.target.value = "";
  };
  const handleDeleteFileCV = () => {
    setFileCV({
      verification_id: null,
      value: null,
      status: "pending",
      rejection_reason: null,
      rejection_comment: null,
      rejection_timestamp: null,
      rejected_by: null,
      comments: [],
    });
    if (fileCVRef && fileCVRef.current) {
      fileCVRef.current.value = null;
    }
  };
  const handleFileChangePhotographicIdFirst = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (filePhotoGraphicIdNonAusRef.current) {
          filePhotoGraphicIdNonAusRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error"
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setfilePhotographicIdFirst({
              ...filePhotographicIdFirst,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: "error" };
          }
        } catch (err) {
          setfilePhotographicIdFirst({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: "error" };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
    e.target.value = "";
  };
  const handleFileChangePhotographicIdSecond = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (filePhotoGraphicIdNonAusRefSecond.current) {
          filePhotoGraphicIdNonAusRefSecond.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error"
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setfilePhotographicIdSecond({
              ...filePhotographicIdSecond,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: "error" };
          }
        } catch (err) {
          setfilePhotographicIdSecond({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: "error" };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
    e.target.value = "";
  };
  const handleDeleteFilePhotographicIdFirst = () => {
    setfilePhotographicIdFirst({
      verification_id: null,
      value: null,
      status: "pending",
      rejection_reason: null,
      rejection_comment: null,
      rejection_timestamp: null,
      rejected_by: null,
      comments: [],
    });
    if (filePhotoGraphicIdNonAusRef && filePhotoGraphicIdNonAusRef.current) {
      filePhotoGraphicIdNonAusRef.current.value = null;
    }
  };
  const handleDeleteFilePhotographicIdSecond = () => {
    setfilePhotographicIdSecond({
      verification_id: null,
      value: null,
      status: "pending",
      rejection_reason: null,
      rejection_comment: null,
      rejection_timestamp: null,
      rejected_by: null,
      comments: [],
    });
    if (
      filePhotoGraphicIdNonAusRefSecond &&
      filePhotoGraphicIdNonAusRefSecond.current
    ) {
      filePhotoGraphicIdNonAusRefSecond.current.value = null;
    }
  };
  const handleFileChangeDriverLincenseBackFirst = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (driverLicenseBackRefFirst.current) {
          driverLicenseBackRefFirst.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error"
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileDriverLinsenceBackFirst({
              ...fileDriverLinsenceBackFirst,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: "error" };
          }
        } catch (err) {
          setFileDriverLinsenceBackFirst({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: "error" };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
    e.target.value = "";
  };
  const handleFileChangeDriverLincenseBackSecond = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (driverLicenseBackRefSecond.current) {
          driverLicenseBackRefSecond.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error"
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileDriverLinsenceBackSecond({
              ...fileDriverLinsenceBackSecond,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: "error" };
          }
        } catch (err) {
          setFileDriverLinsenceBackSecond({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: "error" };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
    e.target.value = "";
  };
  const handleContinue = (isFinal) => {
    if (applicantCountry == 14 && !photoId) {
      showToast("Please select photographic ID", "error");
      return;
    }
    if (!nonphotoId) {
      showToast("Please select non photographic ID", "error");
      return;
    }
    if (!fileNonPhotographicId.value) {
      showToast("Please upload non photographic ID document", "error");
      return;
    }
    if (personalDataId == 1 && !fileCV.value) {
      showToast("Please upload your CV", "error");
      return;
    }
    if (personalDataId == 2 && !webLink.value) {
      showToast("Please add your weblink", "error");
      return;
    }
    if (signatory.value == true && !description.value) {
      showToast("Please enter description", "error");
      return;
    }
    if (signatory == "yes" && !fileProof.value) {
      showToast("Please upload proof", "error");
      return;
    }
    if (!fileThirdParty.value) {
      showToast("Please upload Contracts with third parties document", "error");
      return;
    }
    if (applicantCountry == 14 && photoId != 2) {
      if (!filePhotographicId.value) {
        showToast("Please upload valid Photographic ID", "error");
        return;
      }
      if (!expiryDate.value) {
        showToast("Please add the document expiry date.", "error");
        return;
      }
      if (!documentNumber.value) {
        showToast(
          "Please enter a valid number as mentioned on the document.",
          "error"
        );
        return;
      }
    }
    if (applicantCountry == 14 && photoId == 2) {
      if (!fileDriverLinsenceFront.value) {
        showToast(
          "Please upload the front side of your driver’s license.",
          "error"
        );
        return;
      }
      if (!fileDriverLinsenceBack.value) {
        showToast(
          "Please upload the back side of your driver’s license.",
          "error"
        );
        return;
      }
      if (!expiryDate.value) {
        showToast("Please add the document expiry date.", "error");
        return;
      }
      if (!documentNumber.value) {
        showToast(
          "Please enter a valid number as mentioned on the document.",
          "error"
        );
        return;
      }
    }

    if (applicantCountry != 14 && !photoIdFirst && !photoIdSecond) {
      showToast("Please select valid photo ids.", "error");
      return;
    }
    if (applicantCountry != 14 && photoIdFirst != 2 && photoIdSecond != 2) {
      if (!filePhotographicIdFirst.value) {
        showToast("Please upload valid Photographic ID", "error");
        return;
      }
      if (!expiryDate.value) {
        showToast("Please add the document expiry date.", "error");
        return;
      }
      if (!documentNumber.value) {
        showToast(
          "Please enter a valid number as mentioned on the document.",
          "error"
        );
        return;
      }
      if (!filePhotographicIdSecond.value) {
        showToast("Please upload valid Photographic ID", "error");
        return;
      }
      if (!expiryDateSecond.value) {
        showToast("Please add the document expiry date.", "error");
        return;
      }
      if (!documentNumberSecond.value) {
        showToast(
          "Please enter a valid number as mentioned on the document.",
          "error"
        );
        return;
      }
    }
    if (applicantCountry != 14 && photoIdFirst != 2 && photoIdSecond == 2) {
      if (!filePhotographicIdFirst.value) {
        showToast("Please upload valid Photographic ID", "error");
        return;
      }
      if (!expiryDate.value) {
        showToast("Please add the document expiry date.", "error");
        return;
      }
      if (!documentNumber.value) {
        showToast(
          "Please enter a valid number as mentioned on the document.",
          "error"
        );
        return;
      }
      if (!fileDriverLinsenceFrontSecond.value) {
        showToast(
          "Please upload the front side of your driver’s license.",
          "error"
        );
        return;
      }
      if (!fileDriverLinsenceBackSecond.value) {
        showToast(
          "Please upload the back side of your driver’s license.",
          "error"
        );
        return;
      }
      if (!expiryDateSecond.value) {
        showToast("Please add the document expiry date.", "error");
        return;
      }
      if (!documentNumberSecond.value) {
        showToast(
          "Please enter a valid number as mentioned on the document.",
          "error"
        );
        return;
      }
    }
    if (applicantCountry != 14 && photoIdFirst == 2 && photoIdSecond != 2) {
      if (!fileDriverLinsenceFrontFirst.value) {
        showToast(
          "Please upload the front side of your driver’s license.",
          "error"
        );
        return;
      }
      if (!fileDriverLinsenceBackFirst.value) {
        showToast(
          "Please upload the back side of your driver’s license.",
          "error"
        );
        return;
      }
      if (!expiryDate.value) {
        showToast("Please add the document expiry date.", "error");
        return;
      }
      if (!documentNumber.value) {
        showToast(
          "Please enter a valid number as mentioned on the document.",
          "error"
        );
        return;
      }
      if (!filePhotographicIdSecond.value) {
        showToast("Please upload valid Photographic ID", "error");
        return;
      }

      if (!expiryDateSecond.value) {
        showToast("Please add the document expiry date.", "error");
        return;
      }
      if (!documentNumberSecond.value) {
        showToast(
          "Please enter a valid number as mentioned on the document.",
          "error"
        );
        return;
      }
    }
    setLoading(true);
    handlesave(isFinal);
  };
  const handleReset = () => {
    setCurrentStep(1);
  };
  const handleBack = () => {
    if (!isInvitee) {
      setCurrentStep(5);
    }
    if (isInvitee) {
      setCurrentStep(2);
    }
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const getAllEnums = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/advisor/onboarding/proof-documents/enums`
      );

      if (response.status == 200) {
        let AllAccount = [];
        response.data.photographic_document_types.forEach((profile) => {
          AllAccount.push({
            value: profile.value,
            label: profile.name,
          });
        });

        setphotographicIdData(AllAccount);
        let AllAccount2 = [];
        response.data.non_photogenic_id_types.forEach((profile) => {
          AllAccount2.push({
            value: profile.value,
            label: profile.name,
          });
        });
        setnonPhotoData(AllAccount2);

        let AllAccount3 = [];
        response.data.personal_details_types.forEach((profile) => {
          AllAccount3.push({
            value: profile.value,
            label: profile.name,
          });
        });
        setpersonalData(AllAccount3);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getApplicantCountry = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/advisor/onboarding/customer/${customerId}/applicant-country`
      );

      if (response.status == 200) {
        setApplicantCountry(response.data.id);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const submitApplicationAPI = async (isFinal) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/v1/advisor/onboarding/proof-documents/customer/${customerId}/submit`;
    let bodyData = {};

    if (applicantCountry == 14 && photoId != 2) {
      bodyData = {
        contract_files: [
          {
            file_id: fileThirdParty.value.file_id,
            file_name: fileThirdParty.value.file_name,
          },
        ],

        has_prosecution_history: signatory.value,
        prosecution_description: description.value,
        prosecution_file: fileProof.value
          ? {
              file_id: fileProof.value.file_id,
              file_name: fileProof.value.file_name,
            }
          : null,

        photographic_documents: [
          {
            document_type: photoId,
            file: {
              file_id: filePhotographicId.value.file_id,
              file_name: filePhotographicId.value.file_name,
            },
            expiry_date: expiryDate.value,
            document_number: documentNumber.value,
          },
        ],
        non_photogenic_id_type: nonphotoId,
        non_photogenic_file: {
          file_id: fileNonPhotographicId.value.file_id,
          file_name: fileNonPhotographicId.value.file_name,
        },
        personal_details_type: personalDataId,

        cv_file: fileCV.value
          ? {
              file_id: fileCV.value.file_id,
              file_name: fileCV.value.file_name,
            }
          : null,
        website_link: webLink.value,
        is_submitted: isFinal,
      };
    }
    if (applicantCountry == 14 && photoId == 2) {
      bodyData = {
        is_submitted: isFinal,
        contract_files: [
          {
            file_id: fileThirdParty.value.file_id,
            file_name: fileThirdParty.value.file_name,
          },
        ],
        has_prosecution_history: signatory.value,
        prosecution_description: description.value,
        prosecution_file: fileProof.value
          ? {
              file_id: fileProof.value.file_id,
              file_name: fileProof.value.file_name,
            }
          : null,

        photographic_documents: [
          {
            document_type: photoId,
            file: {
              file_id: fileDriverLinsenceFront.value.file_id,
              file_name: fileDriverLinsenceFront.value.file_name,
            },
            back_file: {
              file_id: fileDriverLinsenceBack.value.file_id,
              file_name: fileDriverLinsenceBack.value.file_name,
            },
            expiry_date: expiryDate.value,
            document_number: documentNumber.value,
          },
        ],
        non_photogenic_id_type: nonphotoId,
        non_photogenic_file: {
          file_id: fileNonPhotographicId.value.file_id,
          file_name: fileNonPhotographicId.value.file_name,
        },
        personal_details_type: personalDataId,
        cv_file: fileCV.value
          ? {
              file_id: fileCV.value.file_id,
              file_name: fileCV.value.file_name,
            }
          : null,
        website_link: webLink.value,
      };
    }
    if (applicantCountry != 14 && photoIdFirst != 2 && photoIdSecond != 2) {
      bodyData = {
        is_submitted: isFinal,
        contract_files: [
          {
            file_id: fileThirdParty.value.file_id,
            file_name: fileThirdParty.value.file_name,
          },
        ],
        has_prosecution_history: signatory.value,
        prosecution_description: description.value,
        prosecution_file: fileProof.value
          ? {
              file_id: fileProof.value.file_id,
              file_name: fileProof.value.file_name,
            }
          : null,
        photographic_documents: [
          {
            document_type: photoIdFirst,
            file: {
              file_id: filePhotographicIdFirst.value.file_id,
              file_name: filePhotographicIdFirst.value.file_name,
            },
            expiry_date: expiryDate.value,
            document_number: documentNumber.value,
          },
          {
            document_type: photoIdSecond,
            file: {
              file_id: filePhotographicIdSecond.value.file_id,
              file_name: filePhotographicIdSecond.value.file_name,
            },
            document_number: documentNumberSecond.value,
            expiry_date: expiryDateSecond.value,
          },
        ],
        non_photogenic_id_type: nonphotoId,
        non_photogenic_file: {
          file_id: fileNonPhotographicId.value.file_id,
          file_name: fileNonPhotographicId.value.file_name,
        },
        personal_details_type: personalDataId,
        cv_file: fileCV.value
          ? {
              file_id: fileCV.value.file_id,
              file_name: fileCV.value.file_name,
            }
          : null,
        website_link: webLink.value,
      };
    }
    if (applicantCountry != 14 && photoIdFirst != 2 && photoIdSecond == 2) {
      bodyData = {
        is_submitted: isFinal,
        contract_files: [
          {
            file_id: fileThirdParty.value.file_id,
            file_name: fileThirdParty.value.file_name,
          },
        ],
        has_prosecution_history: signatory.value,
        prosecution_description: description.value,
        prosecution_file: fileProof.value
          ? {
              file_id: fileProof.value.file_id,
              file_name: fileProof.value.file_name,
            }
          : null,

        photographic_documents: [
          {
            document_type: photoIdFirst,
            file: {
              file_id: filePhotographicIdFirst.value.file_id,
              file_name: filePhotographicIdFirst.value.file_name,
            },
            expiry_date: expiryDate.value,
            document_number: documentNumber.value,
          },
          {
            document_type: photoIdSecond,
            file: {
              file_id: fileDriverLinsenceFrontSecond.value.file_id,
              file_name: fileDriverLinsenceFrontSecond.value.file_name,
            },
            back_file: {
              file_id: fileDriverLinsenceBackSecond.value.file_id,
              file_name: fileDriverLinsenceBackSecond.value.file_name,
            },
            expiry_date: expiryDateSecond.value,
            document_number: documentNumberSecond.value,
          },
        ],
        non_photogenic_id_type: nonphotoId,
        non_photogenic_file: {
          file_id: fileNonPhotographicId.value.file_id,
          file_name: fileNonPhotographicId.value.file_name,
        },
        personal_details_type: personalDataId,
        cv_file: fileCV.value
          ? {
              file_id: fileCV.value.file_id,
              file_name: fileCV.value.file_name,
            }
          : null,
        website_link: webLink.value,
      };
    }
    if (applicantCountry != 14 && photoIdFirst == 2 && photoIdSecond != 2) {
      bodyData = {
        is_submitted: isFinal,
        contract_files: [
          {
            file_id: fileThirdParty.value.file_id,
            file_name: fileThirdParty.value.file_name,
          },
        ],
        has_prosecution_history: signatory.value,
        prosecution_description: description.value,
        prosecution_file: fileProof.value
          ? {
              file_id: fileProof.value.file_id,
              file_name: fileProof.value.file_name,
            }
          : null,
        photographic_documents: [
          {
            document_type: photoIdFirst,
            file: {
              file_id: fileDriverLinsenceFrontFirst.value.file_id,
              file_name: fileDriverLinsenceFrontFirst.value.file_name,
            },
            back_file: {
              file_id: fileDriverLinsenceBackFirst.value.file_id,
              file_name: fileDriverLinsenceBackFirst.value.file_name,
            },
            expiry_date: expiryDate.value,
            document_number: documentNumber.value,
          },
          {
            document_type: photoIdSecond,
            file: {
              file_id: filePhotographicIdSecond.value.file_id,
              file_name: filePhotographicIdSecond.value.file_name,
            },
            expiry_date: expiryDateSecond.value,
            document_number: documentNumberSecond.value,
          },
        ],
        non_photogenic_id_type: nonphotoId,
        non_photogenic_file: {
          file_id: fileNonPhotographicId.value.file_id,
          file_name: fileNonPhotographicId.value.file_name,
        },
        personal_details_type: personalDataId,
        cv_file: fileCV.value
          ? {
              file_id: fileCV.value.file_id,
              file_name: fileCV.value.file_name,
            }
          : null,
        website_link: webLink.value,
      };
    }
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handlesave = async (isFinal) => {
    let toastMessage = null;
    try {
      const response = await submitApplicationAPI(isFinal);
      if (response.status == 200) {
        if (isFinal) {
          if (!isInvitee) {
            setCurrentStep(7);
          } else {
            setCurrentStep(4);
          }
          toastMessage = {
            message: response.message,
            type: "success",
          };
          const responseStatus = await GetAPIcalls(
            `/v1/advisor/onboarding/customer/${customerId}/status`
          );
          if (responseStatus.status == 200) {
            if (responseStatus.data.length > 0) {
              dispatch(setStepStatus(responseStatus.data));
            }
          }
        } else {
          toastMessage = {
            message:
              "Information has been saved successfully. Please submit to proceed further.",
            type: "success",
          };
        }
      } else {
        toastMessage = { message: response.message, type: "error" };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: "error" };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const getDetails = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/advisor/onboarding/proof-documents/customer/${customerId}/verification/preview`
      );

      if (response.status == 200) {
        setFileThirdParty(response.data.contract_files);
        setDescription(response.data.prosecution_description);
        setFileProof(response.data.prosecution_file);
        setSignatory(response.data.has_prosecution_history);
        if (response.data.applicant_country.value.id == 14) {
          setphotoId(
            response.data.photographic_documents[0].document_type.value
          );
          // setExpiryDate(
          //   response.data.photographic_documents[0].expiry_date.split("T")[0]
          // );
          setExpiryDate(response.data.photographic_documents[0].expiry_date);
          setDocumentNumber(
            response.data.photographic_documents[0].document_number
          );
          if (
            response.data.photographic_documents[0].document_type.value != 2
          ) {
            setFilePhotographicId(response.data.photographic_documents[0].file);
          }
          if (
            response.data.photographic_documents[0].document_type.value == 2
          ) {
            setFileDriverLinsenceFront(
              response.data.photographic_documents[0].file
            );
            setFileDriverLinsenceBack(
              response.data.photographic_documents[0].back_file
            );
          }
        }
        if (response.data.applicant_country.value.id != 14) {
          setphotoIdFirst(
            response.data.photographic_documents[0].document_type.value
          );
          if (response.data.photographic_documents[1]) {
            setphotoIdSecond(
              response.data.photographic_documents[1].document_type.value
            );
            setDocumentNumberSecond(
              response.data.photographic_documents[1].document_number
            );
            setExpiryDateSecond(
              response.data.photographic_documents[1].expiry_date
            );
          }

          setDocumentNumber(
            response.data.photographic_documents[0].document_number
          );
          setExpiryDate(response.data.photographic_documents[0].expiry_date);

          if (
            response.data.photographic_documents[0].document_type.value != 2
          ) {
            setfilePhotographicIdFirst(
              response.data.photographic_documents[0].file
            );
          }
          if (
            response.data.photographic_documents[0].document_type.value == 2
          ) {
            setFileDriverLinsenceFrontFirst(
              response.data.photographic_documents[0].file
            );
            setFileDriverLinsenceBackFirst(
              response.data.photographic_documents[0].back_file
            );
          }
          if (
            response.data.photographic_documents[1] &&
            response.data.photographic_documents[1].document_type.value != 2
          ) {
            setfilePhotographicIdSecond(
              response.data.photographic_documents[1].file
            );
          }
          if (
            response.data.photographic_documents[1] &&
            response.data.photographic_documents[1].document_type.value == 2
          ) {
            setFileDriverLinsenceFrontSecond(
              response.data.photographic_documents[1].file
            );
            setFileDriverLinsenceBackSecond(
              response.data.photographic_documents[1].back_file
            );
          }
        }
        setNonphotoId(response.data.non_photogenic_id_type.value);
        setNonphotoIdText(response.data.non_photogenic_id_type_name.value);
        setpreselectedNonPhotoId({
          value: response.data.non_photogenic_id_type.value,
          label: response.data.non_photogenic_id_type_name.value,
        });
        setfileNonPhotographicId(response.data.non_photogenic_file);
        setPersonalDataId(response.data.personal_details_type.value);
        setPersonalDataIdText(response.data.personal_details_type_name.value);
        setpreselectedPersonal({
          value: response.data.personal_details_type.value,
          label: response.data.personal_details_type_name.value,
        });
        if (response.data.cv_file) {
          setFileCV(response.data.cv_file);
        }
        setWebLink(response.data.website_link);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };

  useEffect(() => {
    getAllEnums();
    getApplicantCountry();
  }, []);
  useEffect(() => {
    if (
      (!isInvitee &&
        stepStatus.length > 0 &&
        stepStatus[5].status != "DRAFT") ||
      (isInvitee && stepStatus.length > 0 && stepStatus[2].status != "DRAFT")
    ) {
      getDetails();
    }
  }, [stepStatus]);
  useEffect(() => {
    if (
      (!isInvitee &&
        updateFieldStatus &&
        stepStatus.length > 0 &&
        stepStatus[5].status != "DRAFT") ||
      (isInvitee &&
        updateFieldStatus &&
        stepStatus.length > 0 &&
        stepStatus[2].status != "DRAFT")
    ) {
      getDetails();
    }
  }, [updateFieldStatus, stepStatus]);
  return (
    <div className="flex flex-col min-h-[calc(100vh-100px)] lg:min-w-[80vw] lg:max-w-[80vw]">
      <div className="flex-grow  overflow-visible">
        {loading && (
          <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
        {((!isInvitee &&
          stepStatus.length > 0 &&
          (stepStatus[5].status == "IN_REVIEW" ||
            stepStatus[5].status == "COMPLETED")) ||
          (isInvitee &&
            stepStatus.length > 0 &&
            (stepStatus[2].status == "IN_REVIEW" ||
              stepStatus[2].status == "COMPLETED"))) && (
          <div className="mb-2 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-3 rounded-md text-sm flex items-center">
            <img
              src="/warning-circle.svg"
              alt="Info"
              className="w-4 h-4 mr-2"
            />
            <span>
              This section is <strong>in review by our onboarding team</strong>.
              You will be notified once the verification is complete.{" "}
            </span>
          </div>
        )}
        {((!isInvitee &&
          stepStatus.length > 0 &&
          stepStatus[5].status == "APPROVED") ||
          (isInvitee &&
            stepStatus.length > 0 &&
            stepStatus[2].status == "APPROVED")) && (
          <div className="mb-2 bg-green-100 border-l-4 border-green-500 text-green-700 p-3 rounded-md text-sm flex items-center">
            <span>
              This section has been <strong>approved</strong> by our onboarding
              team.
            </span>
          </div>
        )}
        <>
          <div className="bg-white shadow-md rounded-md p-4">
            <div className="border-b border-colour-custom pb-2">
              <div className="flex items-center space-x-2 mb-2">
                <img src="/note-2.svg" alt="User Avatar" className="h-6 w-6" />
                <h1 className="text-xl font-medium">Upload Proof Documents</h1>
              </div>

              <ul className="space-y-2 pl-6 pr-2 text-xs font-medium text-black list-disc">
                <li>
                  Please submit all colour copies of the necessary documents.
                </li>
                <li>
                  Resubmitting the application is required if the documents are
                  not submitted in colour.
                </li>
                <li className="text-[#FF5050]">
                  If you need to adjust any information from the previous
                  section, please click on the “Reset Application” button.
                </li>
              </ul>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
              {/* first column */}
              <div className="flex flex-col px-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                <div className="flex items-center justify-between"></div>
                <LabelWithStatus
                  id="contracttype"
                  label="Contracts with third parties to verify the intended
                    transaction"
                  required={true}
                  fieldData={fileThirdParty}
                  handleStatusClick={handleStatusClick}
                />
                {/* Drag & Drop Upload Area */}
                <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                  <input
                    type="file"
                    id="fileUpload"
                    accept=".pdf,.png,.jpeg"
                    ref={fileThirdPartyRef}
                    onChange={handleFileChangeThirdParty}
                    className="hidden"
                  />
                  <img
                    src="/folder-add.svg"
                    alt="Success Icon"
                    className="h-4 w-4"
                  />{" "}
                  <p className="mt-2 text-gray-500 text-sm">
                    Drag & Drop <br />
                    or <span className="underline">Click to Upload</span>
                  </p>
                </label>
                <div className="mt-1">
                  <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    PNG
                  </span>
                  <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    JPEG
                  </span>
                  <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    PDF
                  </span>
                  <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    &#60; 10 MB
                  </span>
                </div>
                {fileThirdParty && fileThirdParty.value && (
                  <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                    <div
                      onClick={(e) => {
                        e.preventDefault();
                        handleFileClick(e, fileThirdParty.value);
                      }}
                      className="flex-col flex"
                    >
                      <span className="text-black cursor-pointer underline">
                        {fileThirdParty.value.file_name}
                      </span>
                      <span className="text-[#46DA55] text-xs">
                        Upload Completed
                      </span>
                    </div>
                    <button
                      onClick={handleDeleteFileThirdParty}
                      className="text-red-500 flex-shrink-0 font-semibold"
                    >
                      <img
                        src="/trash.svg"
                        alt="Success Icon"
                        className="h-4 w-4 flex-shrink-0"
                      />
                    </button>
                  </div>
                )}
              </div>
              {/* second column */}
              <div className="flex flex-col pr-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                <div className="flex flex-col md:flex-col md:items-left md:justify-between gap-2">
                  <label
                    htmlFor="investmentType"
                    className="block whitespace-normal break-words text-sm text-labelColour flex items-center"
                  >
                    Details of any current or recent prosecutions and inquiries
                    related to Money Laundering, terrorist links, tax offences
                    and corruption in respect of the Individual
                    <span className="text-red-500">*</span>
                  </label>

                  {/* Radio Buttons */}
                  <div className="flex items-center gap-4">
                    <label className="flex items-center text-sm text-black">
                      <input
                        type="radio"
                        name="signatory"
                        value={true}
                        checked={signatory.value === true}
                        onChange={(e) => {
                          setDescription({
                            verification_id: null,
                            value: "",
                            status: "pending",
                            rejection_reason: null,
                            rejection_comment: null,
                            rejection_timestamp: null,
                            rejected_by: null,
                            comments: [],
                          });
                          setFileProof({
                            verification_id: null,
                            value: null,
                            status: "pending",
                            rejection_reason: null,
                            rejection_comment: null,
                            rejection_timestamp: null,
                            rejected_by: null,
                            comments: [],
                          });
                          const value = e.target.value === "true"; // convert string → boolean
                          setSignatory({
                            ...signatory,
                            value: value,
                          });
                        }}
                        className="confirm-check w-4 h-4 text-[#005A9C] border-gray-300 focus:ring-[#005A9C]"
                      />
                      <span className="ml-2">Yes</span>
                    </label>

                    <label className="flex items-center text-sm text-black">
                      <input
                        type="radio"
                        name="signatory"
                        value={false}
                        checked={signatory.value == false}
                        onChange={(e) => {
                          setDescription({
                            verification_id: null,
                            value: "",
                            status: "pending",
                            rejection_reason: null,
                            rejection_comment: null,
                            rejection_timestamp: null,
                            rejected_by: null,
                            comments: [],
                          });
                          setFileProof({
                            verification_id: null,
                            value: null,
                            status: "pending",
                            rejection_reason: null,
                            rejection_comment: null,
                            rejection_timestamp: null,
                            rejected_by: null,
                            comments: [],
                          });
                          const value = e.target.value === "true"; // convert string → boolean
                          setSignatory({
                            ...signatory,
                            value: value,
                          });
                        }}
                        className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#005A9C]"
                      />
                      <span className="ml-2">No</span>
                    </label>
                  </div>
                </div>
                {signatory.value === true && (
                  <div className="mt-4">
                    <LabelWithStatus
                      id="description"
                      label="Description"
                      required={true}
                      fieldData={description}
                      handleStatusClick={handleStatusClick}
                    />
                    <textarea
                      id="address"
                      rows="3"
                      value={description.value}
                      onChange={(e) => {
                        setDescription({
                          ...description,
                          value: e.target.value,
                        });
                      }}
                      className="w-full mt-2 p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                      placeholder="Add description..."
                    />
                  </div>
                )}
              </div>
              {/* third column */}
              <div className="flex flex-col pr-4 pt-4">
                {signatory.value === true && (
                  <>
                    {" "}
                    <div className="flex items-center justify-between"></div>
                    <LabelWithStatus
                      id="uploadProof"
                      label="Upload Proof"
                      required={true}
                      fieldData={fileProof}
                      handleStatusClick={handleStatusClick}
                    />
                    {/* Drag & Drop Upload Area */}
                    <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                      <input
                        type="file"
                        id="fileUpload"
                        accept=".pdf,.png,.jpeg"
                        ref={fileProofRef}
                        onChange={handleFileChangeProof}
                        className="hidden"
                      />
                      <img
                        src="/folder-add.svg"
                        alt="Success Icon"
                        className="h-4 w-4"
                      />{" "}
                      <p className="mt-2 text-gray-500 text-sm">
                        Drag & Drop <br />
                        or <span className="underline">Click to Upload</span>
                      </p>
                    </label>
                    <div className="mt-1">
                      <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        PNG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        JPEG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        PDF
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        &#60; 10 MB
                      </span>
                    </div>
                    {fileProof && fileProof.value && (
                      <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                        <div
                          onClick={(e) => {
                            e.preventDefault();
                            handleFileClick(e, fileProof.value);
                          }}
                          className="flex-col flex "
                        >
                          <span className="text-black break-all cursor-pointer underline">
                            {fileProof.value.file_name}
                          </span>
                          <span className="text-[#46DA55] text-xs">
                            Upload Completed
                          </span>
                        </div>
                        <button
                          onClick={handleDeleteFileProof}
                          className="text-red-500 flex-shrink-0 font-semibold"
                        >
                          <img
                            src="/trash.svg"
                            alt="Success Icon"
                            className="h-4 w-4 flex-shrink-0"
                          />
                        </button>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
          {isModalOpen && currentDocument && (
            <DocumentPreview
              fileUrl={currentDocument.presigned_url}
              fileName={currentDocument.file_name}
              onClose={() => setIsModalOpen(false)}
            />
          )}
          <div className="bg-white shadow-md rounded-md p-4 mt-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
              {/* first column */}
              <div className="flex flex-col pr-4 md:px-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                {applicantCountry == 14 && (
                  <>
                    <div className="flex items-center justify-between">
                      <label
                        htmlFor="investmentType"
                        className="text-sm text-labelColour  whitespace-normal break-words block"
                      >
                        Photographic ID<span className="text-red-500">*</span>
                      </label>
                    </div>
                    <label
                      htmlFor="investmentType"
                      className="text-sm text-[#868686]  whitespace-normal break-words block"
                    >
                      A non-photographic ID will be needed if you upload a photo
                      ID that doesn't include your address (such as a passport
                      or a photo ID issued by a state or territory laws).
                    </label>
                    <div className="mt-2">
                      <Dropdown
                        label=""
                        options={photographicIdData}
                        onSelect={handleSelectPhotographicId}
                        preselectedValue={preselectedPhotograpicId}
                      />
                    </div>
                    {(photoId == 1 || photoId == 3) && (
                      <>
                        <div className="flex items-center justify-between">
                          {photoId == 1 && (
                            <LabelWithStatus
                              id="filePhotographicId"
                              label="Upload Certified Copy of Passport"
                              required={true}
                              fieldData={filePhotographicId}
                              handleStatusClick={handleStatusClick}
                            />
                          )}
                          {photoId == 3 && (
                            <LabelWithStatus
                              id="filePhotographicId"
                              label="Upload Photo ID issued under a State or Territory
                              law"
                              required={true}
                              fieldData={filePhotographicId}
                              handleStatusClick={handleStatusClick}
                            />
                          )}
                        </div>
                        {photoId == 1 && (
                          <>
                            <LabelWithStatus
                              id="documentNumber"
                              label="Passport Number"
                              required={true}
                              fieldData={documentNumber}
                              handleStatusClick={handleStatusClick}
                            />
                            <input
                              id="jAccId"
                              name="jAccId"
                              type="text"
                              value={documentNumber.value}
                              placeholder="Enter Number"
                              className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                              onChange={(e) =>
                                setDocumentNumber({
                                  ...documentNumber,
                                  value: e.target.value,
                                })
                              }
                            />
                          </>
                        )}
                        {photoId == 3 && (
                          <>
                            <LabelWithStatus
                              id="documentNumber"
                              label="Document Number"
                              required={true}
                              fieldData={documentNumber}
                              handleStatusClick={handleStatusClick}
                            />
                            <input
                              id="jAccId"
                              name="jAccId"
                              type="text"
                              value={documentNumber.value}
                              placeholder="Enter Number"
                              className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                              onChange={(e) =>
                                setDocumentNumber({
                                  ...documentNumber,
                                  value: e.target.value,
                                })
                              }
                            />
                          </>
                        )}
                        {/* Drag & Drop Upload Area */}
                        <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                          <input
                            type="file"
                            id="fileUpload"
                            accept=".pdf,.png,.jpeg"
                            ref={filePhotoGraphicIdRef}
                            onChange={handleFileChangePhotographicId}
                            className="hidden"
                          />
                          <img
                            src="/folder-add.svg"
                            alt="Success Icon"
                            className="h-4 w-4"
                          />{" "}
                          <p className="mt-2 text-gray-500 text-sm">
                            Drag & Drop <br />
                            or{" "}
                            <span className="underline">Click to Upload</span>
                          </p>
                        </label>
                        <div className="mt-1">
                          <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            PNG
                          </span>
                          <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            JPEG
                          </span>
                          <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            PDF
                          </span>
                          <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            &#60; 10 MB
                          </span>
                        </div>
                        {filePhotographicId && filePhotographicId.value && (
                          <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                            <div
                              onClick={(e) => {
                                e.preventDefault();
                                handleFileClick(e, filePhotographicId.value);
                              }}
                              className="flex-col flex "
                            >
                              <span className="text-black break-all cursor-pointer underline">
                                {filePhotographicId.value.file_name}
                              </span>
                              <span className="text-[#46DA55] text-xs">
                                Upload Completed
                              </span>
                            </div>
                            <button
                              onClick={handleDeleteFilePhotographicId}
                              className="text-red-500 flex-shrink-0 font-semibold"
                            >
                              <img
                                src="/trash.svg"
                                alt="Success Icon"
                                className="h-4 w-4 flex-shrink-0"
                              />
                            </button>
                          </div>
                        )}
                        <p className="text-[10px] mt-2 text-[#363636] bg-[#FFC421] border-[#FFC421] bg-opacity-50 px-2 py-1 border-2 rounded-lg">
                          Please make sure the document you have uploaded is
                          certified.
                        </p>
                      </>
                    )}
                    {photoId == 2 && (
                      <>
                        <div className="flex items-center justify-between">
                          <LabelWithStatus
                            id="fileDriverLinsenceFront"
                            label="Upload Certified Copy of Driver's License (Front)"
                            required={true}
                            fieldData={fileDriverLinsenceFront}
                            handleStatusClick={handleStatusClick}
                          />
                        </div>
                        <LabelWithStatus
                          id="documentNumber"
                          label="Driver's License Number"
                          required={true}
                          fieldData={documentNumber}
                          handleStatusClick={handleStatusClick}
                        />
                        <input
                          id="jAccId"
                          name="jAccId"
                          type="text"
                          value={documentNumber.value}
                          placeholder="Enter Number"
                          className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                          onChange={(e) =>
                            setDocumentNumber({
                              ...documentNumber,
                              value: e.target.value,
                            })
                          }
                        />
                        {/* Drag & Drop Upload Area */}
                        <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                          <input
                            type="file"
                            id="fileUpload"
                            accept=".pdf,.png,.jpeg"
                            ref={driverLicenseFrontRef}
                            onChange={handleFileChangeDriverLincenseFront}
                            className="hidden"
                          />
                          <img
                            src="/folder-add.svg"
                            alt="Success Icon"
                            className="h-4 w-4"
                          />{" "}
                          <p className="mt-2 text-gray-500 text-sm">
                            Drag & Drop <br />
                            or{" "}
                            <span className="underline">Click to Upload</span>
                          </p>
                        </label>
                        <div className="mt-1">
                          <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            PNG
                          </span>
                          <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            JPEG
                          </span>
                          <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            PDF
                          </span>
                          <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            &#60; 10 MB
                          </span>
                        </div>
                        {fileDriverLinsenceFront &&
                          fileDriverLinsenceFront.value && (
                            <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                              <div
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleFileClick(
                                    e,
                                    fileDriverLinsenceFront.value
                                  );
                                }}
                                className="flex-col flex "
                              >
                                <span className="text-black break-all cursor-pointer underline">
                                  {fileDriverLinsenceFront.value.file_name}
                                </span>
                                <span className="text-[#46DA55] text-xs">
                                  Upload Completed
                                </span>
                              </div>
                              <button
                                onClick={handleDeleteDriverLinsenceFront}
                                className="text-red-500 flex-shrink-0 font-semibold"
                              >
                                <img
                                  src="/trash.svg"
                                  alt="Success Icon"
                                  className="h-4 w-4 flex-shrink-0"
                                />
                              </button>
                            </div>
                          )}
                        <p className="text-[10px] mt-2 text-[#363636] bg-[#FFC421] border-[#FFC421] bg-opacity-50 px-2 py-1 border-2 rounded-lg">
                          Please make sure the document you have uploaded is
                          certified.
                        </p>
                        <div className="mt-2 flex items-center justify-between">
                          <LabelWithStatus
                            id="fileDriverLinsenceBack"
                            label="Upload Certified Copy of Driver's License (Back)"
                            required={true}
                            fieldData={fileDriverLinsenceBack}
                            handleStatusClick={handleStatusClick}
                          />
                        </div>
                        {/* Drag & Drop Upload Area */}
                        <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                          <input
                            type="file"
                            id="fileUpload"
                            accept=".pdf,.png,.jpeg"
                            ref={driverLicenseBackRef}
                            onChange={handleFileChangeDriverLincenseBack}
                            className="hidden"
                          />
                          <img
                            src="/folder-add.svg"
                            alt="Success Icon"
                            className="h-4 w-4"
                          />{" "}
                          <p className="mt-2 text-gray-500 text-sm">
                            Drag & Drop <br />
                            or{" "}
                            <span className="underline">Click to Upload</span>
                          </p>
                        </label>
                        <div className="mt-1">
                          <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            PNG
                          </span>
                          <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            JPEG
                          </span>
                          <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            PDF
                          </span>
                          <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            &#60; 10 MB
                          </span>
                        </div>
                        {fileDriverLinsenceBack &&
                          fileDriverLinsenceBack.value && (
                            <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                              <div
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleFileClick(
                                    e,
                                    fileDriverLinsenceBack.value
                                  );
                                }}
                                className="flex-col flex "
                              >
                                <span className="text-black break-all cursor-pointer underline">
                                  {fileDriverLinsenceBack.value.file_name}
                                </span>
                                <span className="text-[#46DA55] text-xs">
                                  Upload Completed
                                </span>
                              </div>
                              <button
                                onClick={handleDeleteDriverLinsenceBack}
                                className="text-red-500 flex-shrink-0 font-semibold"
                              >
                                <img
                                  src="/trash.svg"
                                  alt="Success Icon"
                                  className="h-4 w-4 flex-shrink-0"
                                />
                              </button>
                            </div>
                          )}
                        <p className="text-[10px] mt-2 text-[#363636] bg-[#FFC421] border-[#FFC421] bg-opacity-50 px-2 py-1 border-2 rounded-lg">
                          Please make sure the document you have uploaded is
                          certified.
                        </p>
                      </>
                    )}
                    <div className="mt-2">
                      <LabelWithStatus
                        id="expiryDate"
                        label=" Expiry Date"
                        required={true}
                        fieldData={expiryDate}
                        handleStatusClick={handleStatusClick}
                      />
                      <input
                        type="date"
                        value={expiryDate.value}
                        onChange={(e) =>
                          setExpiryDate({
                            ...expiryDate,
                            value: e.target.value,
                          })
                        }
                        min={getCurrentDate()}
                        className="block w-full p-2 text-black font-medium border border-gray-300 rounded-md text-md"
                      />
                    </div>
                  </>
                )}
                {applicantCountry != 14 && (
                  <>
                    {/* first photo id */}
                    <div className="">
                      <Dropdown
                        label="Select First Photographic ID"
                        options={photographicIdData}
                        onSelect={handleSelectPhotographicIdFirst}
                        preselectedValue={preselectedPhotograpicIdFirst}
                      />
                    </div>
                    {(photoIdFirst == 1 || photoIdFirst == 3) && (
                      <>
                        <div className="flex items-center justify-between">
                          {photoIdFirst == 1 && (
                            <>
                              <LabelWithStatus
                                id="filePhotographicIdFirst"
                                label="Upload Notarised Foreign Government Issued Passport"
                                required={true}
                                fieldData={filePhotographicIdFirst}
                                handleStatusClick={handleStatusClick}
                              />
                            </>
                          )}
                          {photoIdFirst == 3 && (
                            <>
                              <LabelWithStatus
                                id="filePhotographicIdFirst"
                                label="Upload Photo ID issued under a State or
                                Territory law"
                                required={true}
                                fieldData={filePhotographicIdFirst}
                                handleStatusClick={handleStatusClick}
                              />
                            </>
                          )}
                        </div>
                        {photoIdFirst == 1 && (
                          <>
                            <LabelWithStatus
                              id="documentNumber"
                              label="Passport Number"
                              required={true}
                              fieldData={documentNumber}
                              handleStatusClick={handleStatusClick}
                            />
                            <input
                              id="jAccId"
                              name="jAccId"
                              type="text"
                              value={documentNumber.value}
                              placeholder="Enter Number"
                              className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                              onChange={(e) =>
                                setDocumentNumber({
                                  ...documentNumber,
                                  value: e.target.value,
                                })
                              }
                            />
                          </>
                        )}
                        {photoIdFirst == 3 && (
                          <>
                            <LabelWithStatus
                              id="documentNumber"
                              label=" Document Number"
                              required={true}
                              fieldData={documentNumber}
                              handleStatusClick={handleStatusClick}
                            />
                            <input
                              id="jAccId"
                              name="jAccId"
                              type="text"
                              value={documentNumber.value}
                              placeholder="Enter Number"
                              className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                              onChange={(e) =>
                                setDocumentNumber({
                                  ...documentNumber,
                                  value: e.target.value,
                                })
                              }
                            />
                          </>
                        )}
                        {/* Drag & Drop Upload Area */}
                        <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                          <input
                            type="file"
                            id="fileUpload"
                            accept=".pdf,.png,.jpeg"
                            ref={filePhotoGraphicIdNonAusRef}
                            onChange={handleFileChangePhotographicIdFirst}
                            className="hidden"
                          />
                          <img
                            src="/folder-add.svg"
                            alt="Success Icon"
                            className="h-4 w-4"
                          />{" "}
                          <p className="mt-2 text-gray-500 text-sm">
                            Drag & Drop <br />
                            or{" "}
                            <span className="underline">Click to Upload</span>
                          </p>
                        </label>
                        <div className="mt-1">
                          <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            PNG
                          </span>
                          <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            JPEG
                          </span>
                          <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            PDF
                          </span>
                          <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            &#60; 10 MB
                          </span>
                        </div>
                        {filePhotographicIdFirst &&
                          filePhotographicIdFirst.value && (
                            <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                              <div
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleFileClick(
                                    e,
                                    filePhotographicIdFirst.value
                                  );
                                }}
                                className="flex-col flex "
                              >
                                <span className="text-black break-all cursor-pointer underline">
                                  {filePhotographicIdFirst.value.file_name}
                                </span>
                                <span className="text-[#46DA55] text-xs">
                                  Upload Completed
                                </span>
                              </div>
                              <button
                                onClick={handleDeleteFilePhotographicIdFirst}
                                className="text-red-500 flex-shrink-0 font-semibold"
                              >
                                <img
                                  src="/trash.svg"
                                  alt="Success Icon"
                                  className="h-4 w-4 flex-shrink-0"
                                />
                              </button>
                            </div>
                          )}
                        <p className="text-[10px] mt-2 text-[#363636] bg-[#FFC421] border-[#FFC421] bg-opacity-50 px-2 py-1 border-2 rounded-lg">
                          Please make sure the document you have uploaded is
                          certified.
                        </p>
                      </>
                    )}
                    {photoIdFirst == 2 && (
                      <>
                        <div className="flex items-center justify-between">
                          <LabelWithStatus
                            id="fileDriverLinsenceFrontFirst"
                            label="Upload Certified Copy of Driver's License (Front)"
                            required={true}
                            fieldData={fileDriverLinsenceFrontFirst}
                            handleStatusClick={handleStatusClick}
                          />
                        </div>
                        <LabelWithStatus
                          id="documentNumber"
                          label="Driver's License Number"
                          required={true}
                          fieldData={documentNumber}
                          handleStatusClick={handleStatusClick}
                        />
                        <input
                          id="jAccId"
                          name="jAccId"
                          type="text"
                          value={documentNumber.value}
                          placeholder="Enter Number"
                          className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                          onChange={(e) =>
                            setDocumentNumber({
                              ...documentNumber,
                              value: e.target.value,
                            })
                          }
                        />
                        {/* Drag & Drop Upload Area */}
                        <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                          <input
                            type="file"
                            id="fileUpload"
                            accept=".pdf,.png,.jpeg"
                            ref={driverLicenseFrontRefFirst}
                            onChange={handleFileChangeDriverLincenseFrontFirst}
                            className="hidden"
                          />
                          <img
                            src="/folder-add.svg"
                            alt="Success Icon"
                            className="h-4 w-4"
                          />{" "}
                          <p className="mt-2 text-gray-500 text-sm">
                            Drag & Drop <br />
                            or{" "}
                            <span className="underline">Click to Upload</span>
                          </p>
                        </label>
                        <div className="mt-1">
                          <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            PNG
                          </span>
                          <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            JPEG
                          </span>
                          <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            PDF
                          </span>
                          <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            &#60; 10 MB
                          </span>
                        </div>
                        {fileDriverLinsenceFrontFirst &&
                          fileDriverLinsenceFrontFirst.value && (
                            <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                              <div
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleFileClick(
                                    e,
                                    fileDriverLinsenceFrontFirst.value
                                  );
                                }}
                                className="flex-col flex "
                              >
                                <span className="text-black break-all cursor-pointer underline">
                                  {fileDriverLinsenceFrontFirst.value.file_name}
                                </span>
                                <span className="text-[#46DA55] text-xs">
                                  Upload Completed
                                </span>
                              </div>
                              <button
                                onClick={handleDeleteDriverLinsenceFrontFirst}
                                className="text-red-500 flex-shrink-0 font-semibold"
                              >
                                <img
                                  src="/trash.svg"
                                  alt="Success Icon"
                                  className="h-4 w-4 flex-shrink-0"
                                />
                              </button>
                            </div>
                          )}
                        <p className="text-[10px] mt-2 text-[#363636] bg-[#FFC421] border-[#FFC421] bg-opacity-50 px-2 py-1 border-2 rounded-lg">
                          Please make sure the document you have uploaded is
                          certified.
                        </p>
                        <div className="mt-2 flex items-center justify-between">
                          <LabelWithStatus
                            id="fileDriverLinsenceBackFirst"
                            label="Upload Certified Copy of Driver's License (Back)"
                            required={true}
                            fieldData={fileDriverLinsenceBackFirst}
                            handleStatusClick={handleStatusClick}
                          />
                        </div>

                        {/* Drag & Drop Upload Area */}
                        <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                          <input
                            type="file"
                            id="fileUpload"
                            accept=".pdf,.png,.jpeg"
                            ref={driverLicenseBackRefFirst}
                            onChange={handleFileChangeDriverLincenseBackFirst}
                            className="hidden"
                          />
                          <img
                            src="/folder-add.svg"
                            alt="Success Icon"
                            className="h-4 w-4"
                          />{" "}
                          <p className="mt-2 text-gray-500 text-sm">
                            Drag & Drop <br />
                            or{" "}
                            <span className="underline">Click to Upload</span>
                          </p>
                        </label>
                        <div className="mt-1">
                          <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            PNG
                          </span>
                          <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            JPEG
                          </span>
                          <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            PDF
                          </span>
                          <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            &#60; 10 MB
                          </span>
                        </div>
                        {fileDriverLinsenceBackFirst &&
                          fileDriverLinsenceBackFirst.value && (
                            <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                              <div
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleFileClick(
                                    e,
                                    fileDriverLinsenceBackFirst.value
                                  );
                                }}
                                className="flex-col flex "
                              >
                                <span className="text-black break-all cursor-pointer underline">
                                  {fileDriverLinsenceBackFirst.value.file_name}
                                </span>
                                <span className="text-[#46DA55] text-xs">
                                  Upload Completed
                                </span>
                              </div>
                              <button
                                onClick={handleDeleteDriverLinsenceBackFirst}
                                className="text-red-500 flex-shrink-0 font-semibold"
                              >
                                <img
                                  src="/trash.svg"
                                  alt="Success Icon"
                                  className="h-4 w-4 flex-shrink-0"
                                />
                              </button>
                            </div>
                          )}
                        <p className="text-[10px] mt-2 text-[#363636] bg-[#FFC421] border-[#FFC421] bg-opacity-50 px-2 py-1 border-2 rounded-lg">
                          Please make sure the document you have uploaded is
                          certified.
                        </p>
                      </>
                    )}
                    <div className="mt-2">
                      <LabelWithStatus
                        id="expiryDate"
                        label="Expiry Date"
                        required={true}
                        fieldData={expiryDate}
                        handleStatusClick={handleStatusClick}
                      />
                      <input
                        type="date"
                        value={expiryDate.value}
                        onChange={(e) =>
                          setExpiryDate({
                            ...expiryDate,
                            value: e.target.value,
                          })
                        }
                        min={getCurrentDate()}
                        className="block w-full p-2 text-black font-medium border border-gray-300 rounded-md text-md"
                      />
                    </div>
                    {/* second photo id */}
                    <div className="">
                      <Dropdown
                        label="Select Second Photographic ID"
                        options={photographicIdData}
                        onSelect={handleSelectPhotographicIdSecond}
                        preselectedValue={preselectedPhotograpicIdSecond}
                      />
                    </div>
                    {photoIdSecond != 2 && (
                      <>
                        <div className="flex items-center justify-between">
                          {photoIdSecond == 1 && (
                            <>
                              <LabelWithStatus
                                id="filePhotographicIdSecond"
                                label="Upload Notarised Foreign Government Issued Passport"
                                required={true}
                                fieldData={filePhotographicIdSecond}
                                handleStatusClick={handleStatusClick}
                              />
                            </>
                          )}
                          {photoIdSecond == 3 && (
                            <>
                              <LabelWithStatus
                                id="filePhotographicIdSecond"
                                label=" Upload Photo ID issued under a State or Territory law"
                                required={true}
                                fieldData={filePhotographicIdSecond}
                                handleStatusClick={handleStatusClick}
                              />
                            </>
                          )}
                        </div>
                        {photoIdSecond == 1 && (
                          <>
                            <LabelWithStatus
                              id="documentNumberSecond"
                              label="Passport Number"
                              required={true}
                              fieldData={documentNumberSecond}
                              handleStatusClick={handleStatusClick}
                            />
                            <input
                              id="jAccId"
                              name="jAccId"
                              type="text"
                              value={documentNumberSecond.value}
                              placeholder="Enter Number"
                              className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                              onChange={(e) =>
                                setDocumentNumberSecond({
                                  ...documentNumberSecond,
                                  value: e.target.value,
                                })
                              }
                            />
                          </>
                        )}
                        {photoIdSecond == 3 && (
                          <>
                            <LabelWithStatus
                              id="documentNumberSecond"
                              label="Document Number"
                              required={true}
                              fieldData={documentNumberSecond}
                              handleStatusClick={handleStatusClick}
                            />
                            <input
                              id="jAccId"
                              name="jAccId"
                              type="text"
                              value={documentNumberSecond.value}
                              placeholder="Enter Number"
                              className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                              onChange={(e) =>
                                setDocumentNumberSecond({
                                  ...documentNumberSecond,
                                  value: e.target.value,
                                })
                              }
                            />
                          </>
                        )}
                        {/* Drag & Drop Upload Area */}
                        <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                          <input
                            type="file"
                            id="fileUpload"
                            accept=".pdf,.png,.jpeg"
                            ref={filePhotoGraphicIdNonAusRefSecond}
                            onChange={handleFileChangePhotographicIdSecond}
                            className="hidden"
                          />
                          <img
                            src="/folder-add.svg"
                            alt="Success Icon"
                            className="h-4 w-4"
                          />{" "}
                          <p className="mt-2 text-gray-500 text-sm">
                            Drag & Drop <br />
                            or{" "}
                            <span className="underline">Click to Upload</span>
                          </p>
                        </label>
                        <div className="mt-1">
                          <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            PNG
                          </span>
                          <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            JPEG
                          </span>
                          <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            PDF
                          </span>
                          <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            &#60; 10 MB
                          </span>
                        </div>
                        {filePhotographicIdSecond &&
                          filePhotographicIdSecond.value && (
                            <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                              <div
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleFileClick(
                                    e,
                                    filePhotographicIdSecond.value
                                  );
                                }}
                                className="flex-col flex "
                              >
                                <span className="text-black break-all cursor-pointer underline">
                                  {filePhotographicIdSecond.value.file_name}
                                </span>
                                <span className="text-[#46DA55] text-xs">
                                  Upload Completed
                                </span>
                              </div>
                              <button
                                onClick={handleDeleteFilePhotographicIdSecond}
                                className="text-red-500 flex-shrink-0 font-semibold"
                              >
                                <img
                                  src="/trash.svg"
                                  alt="Success Icon"
                                  className="h-4 w-4 flex-shrink-0"
                                />
                              </button>
                            </div>
                          )}
                        <p className="text-[10px] mt-2 text-[#363636] bg-[#FFC421] border-[#FFC421] bg-opacity-50 px-2 py-1 border-2 rounded-lg">
                          Please make sure the document you have uploaded is
                          certified.
                        </p>
                      </>
                    )}
                    {photoIdSecond == 2 && (
                      <>
                        <div className="flex items-center justify-between">
                          <LabelWithStatus
                            id="fileDriverLinsenceFrontSecond"
                            label=" Upload Certified Copy of Driver's License (Front)"
                            required={true}
                            fieldData={fileDriverLinsenceFrontSecond}
                            handleStatusClick={handleStatusClick}
                          />
                        </div>
                        <LabelWithStatus
                          id="documentNumberSecond"
                          label="Driver's License Number"
                          required={true}
                          fieldData={documentNumberSecond}
                          handleStatusClick={handleStatusClick}
                        />
                        <input
                          id="jAccId"
                          name="jAccId"
                          type="text"
                          value={documentNumberSecond.value}
                          placeholder="Enter Number"
                          className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                          onChange={(e) =>
                            setDocumentNumberSecond({
                              ...documentNumberSecond,
                              value: e.target.value,
                            })
                          }
                        />
                        {/* Drag & Drop Upload Area */}
                        <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                          <input
                            type="file"
                            id="fileUpload"
                            accept=".pdf,.png,.jpeg"
                            ref={driverLicenseFrontRefSecond}
                            onChange={handleFileChangeDriverLincenseFrontSecond}
                            className="hidden"
                          />
                          <img
                            src="/folder-add.svg"
                            alt="Success Icon"
                            className="h-4 w-4"
                          />{" "}
                          <p className="mt-2 text-gray-500 text-sm">
                            Drag & Drop <br />
                            or{" "}
                            <span className="underline">Click to Upload</span>
                          </p>
                        </label>
                        <div className="mt-1">
                          <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            PNG
                          </span>
                          <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            JPEG
                          </span>
                          <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            PDF
                          </span>
                          <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            &#60; 10 MB
                          </span>
                        </div>
                        {fileDriverLinsenceFrontSecond &&
                          fileDriverLinsenceFrontSecond.value && (
                            <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                              <div
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleFileClick(
                                    e,
                                    fileDriverLinsenceFrontSecond.value
                                  );
                                }}
                                className="flex-col flex "
                              >
                                <span className="text-black break-all cursor-pointer underline">
                                  {
                                    fileDriverLinsenceFrontSecond.value
                                      .file_name
                                  }
                                </span>
                                <span className="text-[#46DA55] text-xs">
                                  Upload Completed
                                </span>
                              </div>
                              <button
                                onClick={handleDeleteDriverLinsenceFrontSecond}
                                className="text-red-500 flex-shrink-0 font-semibold"
                              >
                                <img
                                  src="/trash.svg"
                                  alt="Success Icon"
                                  className="h-4 w-4 flex-shrink-0"
                                />
                              </button>
                            </div>
                          )}
                        <p className="text-[10px] mt-2 text-[#363636] bg-[#FFC421] border-[#FFC421] bg-opacity-50 px-2 py-1 border-2 rounded-lg">
                          Please make sure the document you have uploaded is
                          certified.
                        </p>
                        <div className="mt-2 flex items-center justify-between">
                          <LabelWithStatus
                            id="fileDriverLinsenceBackSecond"
                            label="Upload Certified Copy of Driver's License (Back)"
                            required={true}
                            fieldData={fileDriverLinsenceBackSecond}
                            handleStatusClick={handleStatusClick}
                          />
                        </div>
                        {/* Drag & Drop Upload Area */}
                        <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                          <input
                            type="file"
                            id="fileUpload"
                            accept=".pdf,.png,.jpeg"
                            ref={driverLicenseBackRefSecond}
                            onChange={handleFileChangeDriverLincenseBackSecond}
                            className="hidden"
                          />
                          <img
                            src="/folder-add.svg"
                            alt="Success Icon"
                            className="h-4 w-4"
                          />{" "}
                          <p className="mt-2 text-gray-500 text-sm">
                            Drag & Drop <br />
                            or{" "}
                            <span className="underline">Click to Upload</span>
                          </p>
                        </label>
                        <div className="mt-1">
                          <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            PNG
                          </span>
                          <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            JPEG
                          </span>
                          <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            PDF
                          </span>
                          <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            &#60; 10 MB
                          </span>
                        </div>
                        {fileDriverLinsenceBackSecond &&
                          fileDriverLinsenceBackSecond.value && (
                            <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                              <div
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleFileClick(
                                    e,
                                    fileDriverLinsenceBackSecond.value
                                  );
                                }}
                                className="flex-col flex "
                              >
                                <span className="text-black break-all cursor-pointer underline">
                                  {fileDriverLinsenceBackSecond.value.file_name}
                                </span>
                                <span className="text-[#46DA55] text-xs">
                                  Upload Completed
                                </span>
                              </div>
                              <button
                                onClick={handleDeleteDriverLinsenceBackSecond}
                                className="text-red-500 flex-shrink-0 font-semibold"
                              >
                                <img
                                  src="/trash.svg"
                                  alt="Success Icon"
                                  className="h-4 w-4 flex-shrink-0"
                                />
                              </button>
                            </div>
                          )}
                        <p className="text-[10px] mt-2 text-[#363636] bg-[#FFC421] border-[#FFC421] bg-opacity-50 px-2 py-1 border-2 rounded-lg">
                          Please make sure the document you have uploaded is
                          certified.
                        </p>
                      </>
                    )}
                    <div className="mt-2">
                      <LabelWithStatus
                        id="expiryDateSecond"
                        label="Expiry Date"
                        required={true}
                        fieldData={expiryDateSecond}
                        handleStatusClick={handleStatusClick}
                      />
                      <input
                        type="date"
                        value={expiryDateSecond.value}
                        onChange={(e) =>
                          setExpiryDateSecond({
                            ...expiryDateSecond,
                            value: e.target.value,
                          })
                        }
                        min={getCurrentDate()}
                        className="block w-full p-2 text-black font-medium border border-gray-300 rounded-md text-md"
                      />
                    </div>
                  </>
                )}
              </div>
              {/* second column */}
              <div className="flex flex-col pr-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                <>
                  <div className="">
                    <Dropdown
                      label={
                        <>
                          Non Photographic ID
                          <span className="text-red-500">*</span>
                        </>
                      }
                      options={nonPhotoData}
                      onSelect={handleSelectNonPhoto}
                      preselectedValue={preselectedNonPhotoId}
                    />
                  </div>
                  <div className="flex items-center justify-between">
                    <LabelWithStatus
                      id="fileNonPhotographicId"
                      label="Upload Document"
                      required={true}
                      fieldData={fileNonPhotographicId}
                      handleStatusClick={handleStatusClick}
                    />
                  </div>
                  {/* Drag & Drop Upload Area */}
                  <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                    <input
                      type="file"
                      id="fileUpload"
                      accept=".pdf,.png,.jpeg"
                      ref={fileNonPhotoGraphicIdRef}
                      onChange={handleFileChangeNonPhotographicId}
                      className="hidden"
                    />
                    <img
                      src="/folder-add.svg"
                      alt="Success Icon"
                      className="h-4 w-4"
                    />{" "}
                    <p className="mt-2 text-gray-500 text-sm">
                      Drag & Drop <br />
                      or <span className="underline">Click to Upload</span>
                    </p>
                  </label>
                  <div className="mt-1">
                    <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                      PNG
                    </span>
                    <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                      JPEG
                    </span>
                    <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                      PDF
                    </span>
                    <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                      &#60; 10 MB
                    </span>
                  </div>
                  {fileNonPhotographicId && fileNonPhotographicId.value && (
                    <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                      <div
                        onClick={(e) => {
                          e.preventDefault();
                          handleFileClick(e, fileNonPhotographicId.value);
                        }}
                        className="flex-col flex "
                      >
                        <span className="text-black break-all cursor-pointer underline">
                          {fileNonPhotographicId.value.file_name}
                        </span>
                        <span className="text-[#46DA55] text-xs">
                          Upload Completed
                        </span>
                      </div>
                      <button
                        onClick={handleDeleteFileNonPhotographicId}
                        className="text-red-500 flex-shrink-0 font-semibold"
                      >
                        <img
                          src="/trash.svg"
                          alt="Success Icon"
                          className="h-4 w-4 flex-shrink-0"
                        />
                      </button>
                    </div>
                  )}
                </>
              </div>
              {/* third column */}
              <div className="flex flex-col pr-4 pt-4">
                <div className="">
                  <Dropdown
                    label={
                      <>
                        Personal Details
                        <span className="text-red-500"> *</span>
                      </>
                    }
                    options={personalData}
                    onSelect={handleSelectPersonal}
                    preselectedValue={preselectedPersonal}
                  />
                </div>
                {personalDataId == 1 && (
                  <>
                    <div className="flex mt-2 items-center justify-between">
                      <LabelWithStatus
                        id="fileCV"
                        label="Upload CV"
                        required={true}
                        fieldData={fileCV}
                        handleStatusClick={handleStatusClick}
                      />
                    </div>
                    {/* Drag & Drop Upload Area */}
                    <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                      <input
                        type="file"
                        id="fileUpload"
                        accept=".pdf,.png,.jpeg"
                        ref={fileCVRef}
                        onChange={handleFileChangeCV}
                        className="hidden"
                      />
                      <img
                        src="/folder-add.svg"
                        alt="Success Icon"
                        className="h-4 w-4"
                      />{" "}
                      <p className="mt-2 text-gray-500 text-sm">
                        Drag & Drop <br />
                        or <span className="underline">Click to Upload</span>
                      </p>
                    </label>
                    <div className="mt-1">
                      <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        PNG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        JPEG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        PDF
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        &#60; 10 MB
                      </span>
                    </div>
                    {fileCV && fileCV.value && (
                      <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                        <div
                          onClick={(e) => {
                            e.preventDefault();
                            handleFileClick(e, fileCV.value);
                          }}
                          className="flex-col flex "
                        >
                          <span className="text-black break-all cursor-pointer underline">
                            {fileCV.value.file_name}
                          </span>
                          <span className="text-[#46DA55] text-xs">
                            Upload Completed
                          </span>
                        </div>
                        <button
                          onClick={handleDeleteFileCV}
                          className="text-red-500 flex-shrink-0 font-semibold"
                        >
                          <img
                            src="/trash.svg"
                            alt="Success Icon"
                            className="h-4 w-4 flex-shrink-0"
                          />
                        </button>
                      </div>
                    )}
                  </>
                )}
                {personalDataId == 2 && (
                  <>
                    <LabelWithStatus
                      id="webLink"
                      label="Website Link"
                      required={true}
                      fieldData={webLink}
                      handleStatusClick={handleStatusClick}
                    />
                    <input
                      id="jAccId"
                      name="jAccId"
                      type="text"
                      value={webLink.value}
                      placeholder="Enter Link"
                      className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                      onChange={(e) =>
                        setWebLink({
                          ...webLink,
                          value: e.target.value,
                        })
                      }
                    />
                  </>
                )}
              </div>
            </div>
          </div>
        </>
      </div>
      {showPopup && currentField && (
        <ReviewPopup
          isOpen={showPopup}
          currentField={currentField}
          currentFieldName={currentFieldName}
          currentFieldValue={currentFieldValue}
          currentFieldType={currentFieldType}
          onClose={() => setShowPopup(false)}
        />
      )}
      <footer className="mb-1 bottom-actions flex flex-col flex-shrink-0 md:flex-row p-4 bg-[#005A9C]">
        {((!isInvitee &&
          stepStatus.length > 0 &&
          stepStatus[5].status != "COMPLETED" &&
          stepStatus[5].status != "APPROVED" &&
          stepStatus[5].status != "IN_REVIEW") ||
          (isInvitee &&
            stepStatus.length > 0 &&
            stepStatus[2].status != "COMPLETED" &&
            stepStatus[2].status != "APPROVED" &&
            stepStatus[2].status != "IN_REVIEW")) && (
          <>
            <div className="flex flex-col md:flex-row items-center justify-start w-full space-y-2 md:space-y-0 relative">
              <ConfirmResetButton onConfirm={handleReset} onBack={handleBack} />
            </div>
            <div className="flex flex-col md:flex-row mt-2 md:mt-0 items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4 relative">
              <div className="relative w-full md:w-auto flex justify-center md:justify-end">
                <button
                  onClick={() => {
                    handleContinue(false);
                  }}
                  className="flex w-full md:w-auto items-center justify-center space-x-2 text-white border-white border-2 font-medium py-2 px-4 rounded-full text-sm"
                >
                  <span>Save as Draft</span>
                </button>
              </div>
              <ConfirmContinueButton
                onContinue={() => handleContinue(true)}
                buttonText="Continue"
                confirmTitle="Save Section"
                confirmMessage="Are you sure, you want to continue. This action will ensure, the saved information is un-editable. Therefore please make sure you have provided the correct details."
              />
            </div>
          </>
        )}
        {((!isInvitee &&
          stepStatus.length > 0 &&
          (stepStatus[5].status == "COMPLETED" ||
            stepStatus[5].status == "APPROVED" ||
            stepStatus[5].status == "IN_REVIEW")) ||
          (isInvitee &&
            stepStatus.length > 0 &&
            (stepStatus[2].status == "COMPLETED" ||
              stepStatus[2].status == "APPROVED" ||
              stepStatus[2].status == "IN_REVIEW"))) && (
          <div className="flex flex-col md:flex-row items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4 relative">
            {/* Save as Draft */}
            <button
              onClick={() => {
                if (!isInvitee) {
                  setCurrentStep(7);
                }
                if (isInvitee) {
                  setCurrentStep(4);
                }
              }}
              className="flex w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-white font-medium py-2 px-4 rounded-full text-sm"
            >
              <span>Next</span>
            </button>
          </div>
        )}
      </footer>
    </div>
  );
};
export default UploadProof;
